// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';

interface WizardStepContentProps {
  children: React.ReactNode;
  footer?: React.ReactNode;
  stepHeadingRef?: React.RefObject<HTMLHeadingElement | null>;
}

export function WizardStepContent({ children, footer, stepHeadingRef }: WizardStepContentProps) {
  return (
    <div
      className="flex flex-col min-h-0 overflow-y-auto bg-[#F5F5F7]"
      style={{ gridArea: 'content' }}
      ref={stepHeadingRef as React.RefObject<HTMLDivElement>}
    >
      <div className="flex flex-col items-center flex-1">
        <div className="bg-white rounded-card w-full max-w-[920px] px-md py-lg mt-xxl mx-[120px] mb-xxl">
          {children}
        </div>
      </div>
      {footer}
    </div>
  );
}
